import z from 'zod';

/**
 * Schema for a base64-encoded file (data, name, type).
 * Compatible with @coolcolduk/util base64ObjectToFile / fileToBase64ObjectNoFileReader.
 */
export const base64ObjectSchema = z.object({
  data: z.string().min(1, 'Base64 data is required'),
  name: z.string().min(1, 'File name is required'),
  type: z.string().min(1, 'MIME type is required'),
});

export interface Base64Object extends z.infer<typeof base64ObjectSchema> {}
/** Alias for form/input use (same shape as Base64Object). */
export type Base64ObjectInput = Base64Object;
